import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Card, Form, Button, Alert } from "react-bootstrap";
import { getMethod, postMethod } from "../../../utils/api-service/api-service";

const SubmitSummaryPage = () => {
    const { id } = useParams();
    const [talk, setTalk] = useState(null);
    const [loading, setLoading] = useState(true);
    const [summary, setSummary] = useState("");
    const [summaryLink, setSummaryLink] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [alreadySubmitted, setAlreadySubmitted] = useState(false);

    useEffect(() => {
        const fetchTalk = async () => {
            setLoading(true);
            const res = await getMethod(`/talks/${id}/get-add-summary-details`);
            if (res?.success && res.talk) {
                setTalk(res.talk);
                if (res.talk.summary && res.talk.summary.length > 0) {
                    setAlreadySubmitted(true);
                }
            } else {
                setErrorMsg(res?.message || "Talk not found or not assigned for summary.");
            }
            setLoading(false);
        };
        fetchTalk();
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMsg("");
        setSuccessMsg("");
        if (!summary.trim()) {
            setErrorMsg("Summary is required.");
            return;
        }
        const res = await postMethod(`/talks/${id}/submit-summary`, {
            summary,
            summaryLink
        });
        if (res?.success) {
            setSuccessMsg("Summary submitted successfully!");
            setAlreadySubmitted(true);
        } else {
            setErrorMsg(res?.message || "Failed to submit summary.");
        }
    };

    if (loading) return <div className="text-center mt-5">Loading...</div>;
    if (errorMsg) return <Container className="py-5"><Alert variant="danger">{errorMsg}</Alert></Container>;

    return (
        <Container className="py-5" style={{ maxWidth: 600 }}>
            <Card>
                <Card.Body>
                    <h3 className="mb-4">Submit Summary</h3>
                    <div className="mb-3">
                        <strong>Talk:</strong> {talk?.title}
                    </div>
                    {alreadySubmitted ? (
                        <Alert variant="success">
                            Summary has already been submitted for this talk. Thank you!
                        </Alert>
                    ) : (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>Summary</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={8}
                                    value={summary}
                                    onChange={e => setSummary(e.target.value)}
                                    placeholder="Paste or write the summary here..."
                                    required
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Summary Link (optional)</Form.Label>
                                <Form.Control
                                    type="url"
                                    value={summaryLink}
                                    onChange={e => setSummaryLink(e.target.value)}
                                    placeholder="https://..."
                                />
                            </Form.Group>
                            <Button type="submit" variant="primary">
                                Submit Summary
                            </Button>
                        </Form>
                    )}
                    {successMsg && <Alert variant="success" className="mt-3">{successMsg}</Alert>}
                    {errorMsg && <Alert variant="danger" className="mt-3">{errorMsg}</Alert>}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default SubmitSummaryPage;